import { Mention } from '@Common/Mentions/models/mention';

export class CoverageImage {
    url: string;
    mention: Mention;
    width: number;
    height: number;
    selected: boolean;
    focused: boolean;
    name: string;
    failed: boolean;
}
